var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoalSolid = function SvgGoalSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 4v17.75a.5.5 0 0 1-1 0V4a.5.5 0 0 1 1 0Zm2.805-.5H19.5c.125 0 .314.235 0 .499-.204.17-3.183 2.544-5.247 4.188a2 2 0 0 0 0 3.128l5.372 4.286c.125.101.125.399-.125.399H8.555a2 2 0 0 1-2-2V5.5a2 2 0 0 1 2-2Z",
    fill: "currentColor"
  })));
};
export default SvgGoalSolid;